import GoogleMapReact from 'google-map-react'

const Map = ({ children, opngo, geoLocation: { x: lat, y: lng } }) => {
    const [map, setMap] = React.useState(null)
    const mapRef = React.useRef(null)

    const getGoogleMapApi = ({ map }) => {
        setMap(map)
    }

    const renderChildrenWithMapProps = () =>
        React.Children.map(children, child =>
            React.cloneElement(child, {
                map: map,
                opngo,
                lat,
                lng,
            })
        )

    return (
        <GoogleMapReact
            ref={mapRef}
            onGoogleApiLoaded={getGoogleMapApi}
            yesIWantToUseGoogleMapApiInternals
            center={{ lat, lng }}
            options={{
                minZoom: 15,
                scrollwheel: false,
                draggable: false,
                zoomControl: false,
                disableDoubleClickZoom: true,
                fullscreenControl: true,
            }}
            zoom={15}>
            {renderChildrenWithMapProps()}
        </GoogleMapReact>
    )
}

export default Map
